export function normalizePreviewUrl(raw: string): string | null {
  const trimmed = raw.trim()
  if (!trimmed) {
    return null
  }

  const withScheme = /^[a-zA-Z][a-zA-Z\d+.-]*:/.test(trimmed) ? trimmed : `https://${trimmed}`

  try {
    const url = new URL(withScheme)
    if (url.protocol !== 'http:' && url.protocol !== 'https:') {
      return null
    }

    return url.toString()
  } catch {
    return null
  }
}

/** The page URL with the parameters that open a debugger session on the unpublished draft. */
export function formatPreviewUrl(raw: string): string | null {
  const normalized = normalizePreviewUrl(raw)
  if (!normalized) {
    return null
  }

  const url = new URL(normalized)
  url.searchParams.set('rmpreview', 'true')
  url.searchParams.set('debug', 'true')

  return url.toString()
}
